import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-info',
			dom: {
				tab: '.js-info-tab',
				panel: '.js-info-panel',
				overlay: '.js-overlay'
			},
			classes: {
				tab: 'b-info__tab_state_active',
				panel: 'b-info__panel_state_active'
			}
		};
		this.options = $.extend(true, {}, defaults, options);
		this.$window = $(window);
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		return this;
	}

	getDom() {
		this.$tab = this.$el.find(this.options.dom.tab);
		this.$panel = this.$el.find(this.options.dom.panel);
		this.$overlay = this.$el.closest(this.options.dom.overlay);
		return this;
	}

	setActiveTab() {
		let $tab = this.$tab.filter('.' + this.options.classes.tab);
		if (!$tab.length) {
			$tab = this.$tab.first();
		}
		const $panel = this.$panel.eq($tab.index());
		const {hash} = $tab.data();
		this.$panel.not($panel).removeClass(this.options.classes.panel);
		$panel.addClass(this.options.classes.panel);
		this.$overlay.data('params', [hash]);
		this.$window.trigger('yota.router.check');
	}

	onClick(event) {
		const $tab = $(event.currentTarget);
		this.$tab.not($tab).removeClass(this.options.classes.tab);
		$tab.addClass(this.options.classes.tab);
		this.setActiveTab();
		event.preventDefault();
	}

	update() {
		const params = this.$overlay.data('params') || [];
		if (params.length) {
			const $tab = this.$tab.filter('[data-hash="' + params[0] + '"]');
			this.$tab.not($tab).removeClass(this.options.classes.tab);
			$tab.addClass(this.options.classes.tab);
			this.setActiveTab();
		}
	}

	activate() {
		const params = this.$overlay.data('params') || [];
		if (params.length) {
			const $tab = this.$tab.filter('[data-hash="' + params[0] + '"]');
			if (!$tab.hasClass(this.options.classes.tab)) {
				$tab.addClass(this.options.classes.tab);
				this.setActiveTab();
			}
			this.$tab.not($tab).removeClass(this.options.classes.tab);
		}
	}

	render() {
		this.getDom();
		if (this.$tab.length) {
			this.$tab.on('click', this.onClick.bind(this));

			this.$overlay
				.on('yota.router.update', this.update.bind(this))
				.on('yota.router.activate', this.activate.bind(this))
				.trigger('yota.router.update')
				.trigger('yota.router.activate');

			this.setActiveTab();
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/info/tabs.js